import { Injectable } from '@angular/core';
import { MemberService } from 'src/app/services/member/member.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilitiesDate } from 'src/app/services/utilities.date';


export interface IMatch {
    startIndex: number;
    length: number;
    text: string;
    fullMatch: string;
}

@Injectable({ providedIn: 'root' })
export class VariableStringParserService {
    constructor(
        private memberService: MemberService,
        private userService: UserService) {

    }

    process(input: string): string {
        let result: string = input;
        let formatted: string = input;
        let match: IMatch;
        let searchIndex = 0;
        while (formatted) {
            match = this.getNextTemplatePositions(formatted, searchIndex);
            if (match) {
                formatted = this.processsMatch(result, match);
                if (formatted) {
                    result = formatted;
                } else {
                    formatted = result;
                    searchIndex = match.startIndex + 1;
                }
                continue;
            }

            formatted = null;
        }

        return result;
    }

    getNextTemplatePositions(input: string, startIndex: number = 0): IMatch {
        if (!input) {
            return null;
        }

        const imputSubstring = input.slice(startIndex);

        const regexp = /<(?<test>([\w\d])+\s+([\w\d])+)\>/;
        const matches = regexp.exec(imputSubstring);
        if (matches && matches.length >= 2) {
            const matchStr = matches[0];
            const matchStrContent = matches[1];
            return { startIndex: imputSubstring.indexOf(matchStr) + startIndex, length: matchStr.length, fullMatch: matchStr, text: matchStrContent } as IMatch;
        }

        return null;
    }

    processsMatch(input: string, match: IMatch): string {
        const [component, request] = match.text.split(' ');
        let replacement: string;
        switch (component.toUpperCase()) {
            case 'MEMBER':
                replacement = this.processMember(request);
                break;
            case 'USER':
                replacement = this.processUser(request);
                break;
        }

        if (replacement) {
            return input.replace(match.fullMatch, replacement);
        }
    }

    processMember(request: string): string {
        const member = this.memberService.memberSync;
        if (!member) {
            return null;
        }

        switch (request.toUpperCase()) {
            case 'SOCIALSECURITY':
                return member.pBP;
            case 'BIRTHDAY':
                return UtilitiesDate.formatDate(member.dateOfBirth);
            case 'FULLNAME':
                return member.fullName;
            case 'FIRSTNAME':
                return member.firstName;
            case 'LASTNAME':
                return member.lastName;
            case 'GENDER':
                const gender = member.gender;
                return gender === 'unknown' ? '<Mr./Ms.>' : gender;

            case 'EMAIL':
                let phoneNumber = member.primaryPhone && member.primaryPhone.number;
                if (phoneNumber && member.primaryPhone.extension) {
                    phoneNumber += `(${member.primaryPhone.extension})`;
                }
                return phoneNumber;

            case 'PHONENUMBER':
                return member.emailAddress;

            default:
                return null;
        }
    }

    processUser(request: string): string {
        const user = this.userService.userSync;
        if (!user) {
            return null;
        }

        if (request.toUpperCase() === 'FULLNAME') {
            return user.fullName;
        } else if (request.toUpperCase() === 'FIRSTNAME') {
            return user.firstName;
        } else if (request.toUpperCase() === 'LASTNAME') {
            return user.lastName;
        } else {
            return null;
        }
    }
}
